<section class="page-control">
  @if (!fixedSize) {
    <div class="page-control__page-size">
      <div>
        <span>{{ 'BATCH_MAILING.PAGINATOR.AMOUNT_OF' | translate }} </span>
        <span>{{ pageSizeItemKey | translate }} </span>
        <span>{{ 'BATCH_MAILING.PAGINATOR.ON_PAGE' | translate }}</span>
      </div>
      <div class="page-control__page-size__control" dropdown>
        <button
          id="button-basic"
          dropdownToggle
          type="button"
          class="dropdown-toggle"
          aria-controls="dropdown-basic"
        >
          {{ savedItemsPerPage ? savedItemsPerPage : items.per_page }}
          <span class="caret"></span>
        </button>
        <ul
          id="dropdown-basic"
          *dropdownMenu
          class="dropdown-menu"
          role="menu"
          aria-labelledby="button-basic"
          [class.position-bottom]="isBottomOrientation"
        >
          @for (size of allowedPageSizes; track size) {
            <li role="menuitem">
              <a
                class="dropdown-item"
                (click)="allowedPageSizesChange({ perPage: size })"
              >
                {{ size }}
              </a>
            </li>
          }
        </ul>
      </div>
    </div>
  }

  <div class="page-control__paginator">
    <div>
      <span>{{ 'BATCH_MAILING.PAGINATOR.PAGE' | translate }} </span>
      <span>{{ items.current_page }} </span>
      <span>{{ 'BATCH_MAILING.PAGINATOR.OUT_OF' | translate }} </span>
      <span>{{ items.last_page }}</span>
    </div>
    <pagination
      [totalItems]="items.total"
      [itemsPerPage]="items.per_page"
      [previousText]="'&nbsp;'"
      [nextText]="'&nbsp;'"
      [maxSize]="4"
      [(ngModel)]="items.current_page"
      (pageChanged)="pageChanged($event)"
    ></pagination>
  </div>
</section>
